import React from 'react';
import PropTypes from 'prop-types';
import styles from './styles';
import { consultLabel, getConsult } from '../../shared/lib';

export default function SubmissionFieldConsult({ context, question, value }) {
  return (
    (!Array.isArray(value) && 'No') || (
      <ul className="consults">
        {value.map((consultId, i) => (
          <li key={i}>
            {consultLabel({
              consult: getConsult(
                context.employee.completedConsults,
                consultId
              ),
              showId: true,
            })}
          </li>
        ))}
      </ul>
    )
  );
}

SubmissionFieldConsult.propTypes = {
  context: PropTypes.object.isRequired,
  question: PropTypes.object.isRequired,
  value: PropTypes.any.isRequired,
};
